import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track3DBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track3DBlue" transform="translate(596.498047, 856.000000)" className="track">
		<g id="line"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			 strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M99.2470703,-1.0658141e-14 L112.374599,18.4360465 C119.135515,27.9309459 119.784687,40.4825004 114.039387,50.6242273 L108.468262,60.4584961 L108.468262,60.4584961"/>
			<path
				d="M101.959473,69.1479492 L101.580157,69.6036972 C95.2616923,77.1953288 87.4081772,83.363877 78.5357602,87.703932 L43.7245376,104.732282 C39.7556546,106.673711 38.1120787,111.464966 40.053508,115.433849 C40.2795488,115.895947 40.5496336,116.335165 40.8600106,116.745402 L42.7575212,119.253415 C46.089746,123.657745 45.2206331,129.929462 40.8163031,133.261686 C40.7249855,133.330775 40.632488,133.398291 40.5388514,133.464203 L23.250305,145.633824 C18.7341283,148.812816 17.6501263,155.050983 20.8291187,159.56716 C22.574399,162.04656 25.3503537,163.600206 28.3763975,163.791221 L36.6035156,164.310547 C60.2225394,165.801465 83.594999,158.787899 102.490899,144.539176 L137.398436,118.21665 C144.571159,112.807956 152.866865,109.078933 161.673355,107.304771 L213.860539,96.7911024 L213.860539,96.7911024"/>
			<path
				d="M226.870117,95 C238.259954,94.0146642 249.677856,96.5480119 259.58217,102.257989 L260.001953,102.5 L260.001953,102.5"/>
		</g>


		<TrackArrow
			transform="translate(228.501953, 95.000000) rotate(-3.000000) translate(-228.501953, -95.000000)"
			points="232.501953 103 224.501953 95 232.501953 87"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<TrackArrow
			transform="translate(100.716309, 70.529297) rotate(130.000000) translate(-100.716309, -70.529297)"
			points="104.716309 78.5292969 96.7163086 70.5292969 104.716309 62.5292969"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track3DBlue')}
			coords="165.029291, 85.781670"
			text="3D"
			textCoordsX="9.92431641"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>

		{/*<g id="line"*/}
		{/*	 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}*/}
		{/*	 strokeLinecap="round"*/}
		{/*	 strokeWidth={tracksWidth}*/}
		{/*>*/}
		{/*	<path*/}
		{/*		d="M434.319757,34.1738281 L430.17402,31.9549159 C419.055635,26.0040513 405.782006,25.6448294 394.358037,30.9856342 L394.017416,31.1448774 L394.017416,31.1448774"*/}
		{/*		strokeWidth={tracksWidth} strokeLinecap="round"/>*/}

		{/*	<path*/}
		{/*		d="M244.978027,12 L165.870439,22.8502541 C162.040305,23.3755884 159.361235,26.9063932 159.886569,30.7365273 C159.978494,31.4067343 160.167083,32.0600772 160.446456,32.6761767 L165.599763,44.0407489 C167.551936,48.3458684 165.644495,53.4184059 161.339376,55.3705784 C159.165844,56.3561744 156.679516,56.3895309 154.480326,55.4625991 L132.302325,46.1148424 C122.143165,41.8328807 110.436324,46.5972909 106.154362,56.7564505 C104.581068,60.4891655 104.180598,64.6121929 105.006144,68.5779072 L108.374069,84.7565842 C110.994378,97.343901 105.302462,110.201483 94.2225025,116.723835 L71.228774,130.259371 C51.0624278,142.130534 34.4743097,159.22499 23.2146808,179.739053 L-2.84217094e-14,222.03418 L-2.84217094e-14,222.03418"*/}
		{/*		strokeWidth={tracksWidth} strokeLinecap="round"/>*/}
		{/*	<path*/}
		{/*		d="M385.555117,35.1010757 L376.25879,39.4471889 C373.757242,40.6166842 370.781274,39.5368422 369.611779,37.0352944 C369.240926,36.2420419 369.084903,35.3653051 369.15932,34.4928127 L370.119128,23.2397745 C370.447678,19.3877674 367.591351,15.9987564 363.739344,15.6702064 C362.574691,15.5708695 361.403703,15.7647603 360.333226,16.2341874 L338.434882,25.8370767 C335.451927,27.1451661 331.973347,25.7874189 330.665258,22.8044633 C329.844426,20.9326457 330.051266,18.769282 331.211914,17.0869141 C334.215888,12.7326322 333.121248,6.76758697 328.766966,3.76361275 C326.89155,2.46978271 324.616342,1.88685253 322.349833,2.11948136 L255.245114,9.00694144 L255.245114,9.00694144"*/}
		{/*		strokeWidth={tracksWidth} strokeLinecap="round"/>*/}
		{/*</g>*/}

		{/*<TrackArrow*/}
		{/*	transform="translate(396.064810, 30.256678) rotate(-381.000000) translate(-396.064810, -30.256678)"*/}
		{/*	points="400.06481 38.2566779 392.06481 30.2566779 400.06481 22.2566779"*/}
		{/*	strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}*/}
		{/*/>*/}
	</g>
);

Track3DBlue.propTypes = trackPropTypes;

export default Track3DBlue;
